export * from './dom';
export * from './form';
export * from './promise';
export * from './translation';

export function range(count: number, start: number = 0, step: number = 1): number[] {
    const nums: number[] = [];

    if (count <= 0) {
        throw new TypeError('count expects a positive integer');
    } else if (step <= 0) {
        throw new TypeError('step expects a positive integer');
    }

    for (let i = 0; i < count; i += step) {
        nums.push(start + i);
    }

    return nums;
}
